import React from 'react';
import { Paper, Typography, Divider, Button, Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { State } from '../../state/reducers';
import { Account } from '../../state/types';
import { userHasAccess } from '../../services/RoleBasedAccess';

interface UserAccountInfoProps {
  openEditAccountModal: (account: Account) => void;
  openChangePasswordModal: () => void;
}

const UserAccountInfo: React.FC<UserAccountInfoProps> = ({ openEditAccountModal, openChangePasswordModal }) => {
  const user: Account = useSelector((state: State) => state.accountState.user);

  return (
    <Paper sx={{ padding: 3, marginBottom: 3, position: "relative" }}>
      <Box sx={{ position: "absolute", top: 8, right: 8 }}>
        <Button variant="contained" color="error" onClick={() => openEditAccountModal(user)} sx={{ marginRight: 1 }}>
          Update
        </Button>
        <Button variant="contained" color="secondary" onClick={openChangePasswordModal}>
          Change Password
        </Button>
      </Box>

      <Typography variant="h5" gutterBottom>
        Account Details
      </Typography>
      <Typography>
        <strong>Email:</strong> {user?.email ?? "Not Available"}
      </Typography>
      <Typography>
        <strong>Name:</strong> {`${user?.first_name ?? "Unknown"} ${user?.last_name ?? ""}`.trim()}
      </Typography>
      <Typography>
        <strong>Phone Number:</strong> {user?.phone_number ?? "Not Available"}
      </Typography>
      <Typography>
        <strong>Role:</strong> {user?.role ?? "Unknown"}
      </Typography>
      <Typography>
        <strong>System Access:</strong> {userHasAccess(user?.role, ["Internal"]) ? "All systems" : user?.system_access?.join(", ") || "None"}
      </Typography>
      <Typography>
        <strong>Account Created:</strong> {user?.createdDate ? new Date(user.createdDate).toLocaleString() : "Unknown"}
      </Typography>
      <Divider sx={{ marginY: 2 }} />
    </Paper>
  );
};

export default UserAccountInfo;
